module.exports = __webpack_public_path__ + "img/02.24fe11db.png";